// extracted by mini-css-extract-plugin
module.exports = {"component":"booking-flow_component__IniY7"};